import * as angular from "angular";
import {IWindowService} from "angular";
import {SplitService} from "./split-service.service";

export class DateRangeContextService {

  /* @ngInject */
  constructor(private $window: IWindowService, private splitService: SplitService, private moment) {
  }

  // ******************************
  // External methods
  // ******************************


  getRange() {
    const siteId = this.splitService.getSiteId();
    const blockingSearchDatesRangeLimit = this.splitService.getBlockingSearchDatesRangeLimit();

    const rangeContext = angular.fromJson(this.$window.localStorage.getItem('dateRangeContext'));
    let rangeRef = rangeContext && rangeContext[siteId] ? rangeContext[siteId] : {};

    if (!!blockingSearchDatesRangeLimit) {
      const now = this.moment().startOf().valueOf();
      if (rangeRef?.from) {
        const difference = this.moment(now).diff(rangeContext[siteId].from);
        if (this.moment.duration(difference).asDays() >= blockingSearchDatesRangeLimit) {
          rangeRef = {};
        }
      }
      if (rangeRef?.to) {
        const difference = this.moment(now).diff(rangeContext[siteId].to);
        if (this.moment.duration(difference).asDays() >= blockingSearchDatesRangeLimit) {
          rangeRef = {};
        }
      }
    }

    return rangeRef;
  }

  setRange(from, to) {
    const siteId = this.splitService.getSiteId();

    let rangeContext = angular.fromJson(this.$window.localStorage.getItem('dateRangeContext'));

    if (!rangeContext) {
      rangeContext = {};
    }

    rangeContext[siteId] = {from: from, to: to};

    this.$window.localStorage.setItem('dateRangeContext', angular.toJson(rangeContext));
  }

}

angular
  .module('bringoz.admin.commons')
  .service('dateRangeContextService', DateRangeContextService);
